// Libs
import classNames from 'classnames/bind';
import { useMemo } from 'react';
import { Grid2, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
// Components, Layouts, Pages
// Others
import { IFormInventory } from '~/utils/interface/inventory';
import { formatTitleCase } from '~/utils/helper/common';
// Styles, images, icons
import styles from './StatusSummaryInventoryForm.module.scss';

type Props = {};

const cx = classNames.bind(styles);

const StatusSummaryInventoryForm = (props: Props) => {
  //#region Destructuring Props
  const {} = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/inventory', 'common/base']);

  const { watch } = useFormContext<IFormInventory>();

  const {
    productId,
    productDesignation,
    warehouseLocation,
    timeCapacity,
    isDamageWaiver,
    isDiscountable,
    isTaxable,
    isShowOnPrint,
    isAddOn,
  } = watch();
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  const valueProductOptions = useMemo(() => {
    const productOptions = [
      isDamageWaiver && t('inventory_form_title_damage_waiver'),
      isDiscountable && t('inventory_form_title_discountable'),
      isTaxable && t('inventory_form_title_taxable'),
      isShowOnPrint && t('inventory_form_title_show_on_print'),
      isAddOn && t('inventory_form_title_add_only_checkbox'),
    ].filter(Boolean);

    return productOptions.join(', ');
  }, [isDamageWaiver, isDiscountable, isTaxable, isShowOnPrint, isAddOn]);
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Stack id='statusSummaryInventoryFormComponent' gap={4}>
      <Typography className={cx('header')}>{t('inventory_form_title_status_summary')}</Typography>

      <Grid2 className={cx('viewBox')} rowSpacing={2} columnSpacing={2} container>
        <Grid2 size={8}>
          <Typography className={cx('textLabel')}>{t('inventory_form_title_product_id_label')}</Typography>
        </Grid2>

        <Grid2 size={4}>
          <Typography className={cx('textValue')}>{productId || t('inventory_form_title_auto_generated')}</Typography>
        </Grid2>

        <Grid2 size={8}>
          <Typography className={cx('textLabel')}>{t('inventory_form_title_designation')}</Typography>
        </Grid2>

        <Grid2 size={4}>
          <Typography className={cx('textValue')}>
            {formatTitleCase(productDesignation) || t('inventory_form_title_not_selected')}
          </Typography>
        </Grid2>

        <Grid2 size={8}>
          <Typography className={cx('textLabel')}>{t('inventory_form_title_location')}</Typography>
        </Grid2>

        <Grid2 size={4}>
          <Typography className={cx('textValue')}>
            {warehouseLocation || t('inventory_form_title_not_specified')}
          </Typography>
        </Grid2>

        {/* <Grid2 size={8}>
          <Typography className={cx('textLabel')}>{t('inventory_form_title_time_capacity_label')}</Typography>
        </Grid2>

        <Grid2 size={4}>
          <Typography className={cx('textValue')}>{timeCapacity || t('inventory_form_title_none')}</Typography>
        </Grid2> */}

        <Grid2 size={8}>
          <Typography className={cx('textLabel')}>{t('inventory_form_title_options')}</Typography>
        </Grid2>

        <Grid2 size={4}>
          <Typography className={cx('textValue')}>{valueProductOptions || t('inventory_form_title_none')}</Typography>
        </Grid2>
      </Grid2>
    </Stack>
  );
};

export default StatusSummaryInventoryForm;
